exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".endorsement-page[data-v-6875f700]{background-color:#f4f7f9;min-height:100vh}.document-container[data-v-6875f700]{max-width:900px;margin:0 auto;background:#fff}.doc-header[data-v-6875f700]{background-color:#1a3a5f}.section-header[data-v-6875f700]{background-color:#e9ecef;border:1px solid #dee2e6;border-bottom:none;color:#333}.section-container .table-bordered[data-v-6875f700]{border-color:#dee2e6}.section-container .table td[data-v-6875f700]{padding:12px;vertical-align:middle}.x-small[data-v-6875f700]{font-size:.75rem}.loading-opacity[data-v-6875f700]{opacity:.5}", ""]);

// exports
